<template>
  <div id="app">
    <router-view v-wechat-title="pageTitle" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isShow: false
    };
  },
  methods: {},
  created() {}
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue